import { defineMessages } from 'react-intl';

export const pathName = Object.freeze({
  PREMIUM: 'premium',
  PLUS: 'plus',
  ARTIST: 'artist',
  ARTISTS: 'artists',
  ALBUM: 'album',
  ALBUMS: 'albums',
  SONG: 'song',
  SONGS: 'songs',
  STATION: 'station',
  PLAYLIST: 'playlist',
  PLAYLISTS: 'playlists',
  PODCAST: 'podcast',
  THUMBS: 'thumbs',
  INFO: 'info',
  NOTICES: 'notices',
  CONTENT: 'content',
  SUBSCRIPTION: 'subscription',
  REDEEM: 'redeem',
  UPGRADE: 'upgrade',
  COLLECTION: 'collection',
  BROWSE: 'browse',
  MUSIC: 'music',
  GENRE: 'genre',
  SEARCH: 'search',
  SETTINGS: 'settings',
  PROFILE: 'profile',
});

export const messages = defineMessages({
  pandoraRadioListenInternet: {
    id: 't.pandoraRadioListenInternet',
    defaultMessage: 'Pandora Radio - Listen to Free Internet Radio, Find New Music',
  },
  pandoraPlusListen: {
    id: 't.pandoraPlusListen',
    defaultMessage:
      'Pandora Plus - Listen with No Ads, Unlimited Skips, Replays, and Offline Stations',
  },
  listenTo: {
    id: 't.listenTo',
    defaultMessage: 'Listen to',
  },
  listenFree: {
    id: 't.listenFree',
    defaultMessage: 'Listen free',
  },
  listenToFreeMusicBy: {
    id: 't.listenToFreeMusicBy',
    defaultMessage: 'Listen to free music by',
  },
  freeOnPandora: {
    id: 't.freeOnPandora',
    defaultMessage: 'Free on Pandora',
  },
  onPandora: {
    id: 't.onPandora',
    defaultMessage: 'on Pandora',
  },
  // start of MetaTags constants that will be used in the future.
  pandoraEnding: {
    id: 't.pandoraEnding',
    defaultMessage: '- Pandora',
  },
  // really need
  pandora: {
    id: 't.pandora',
    defaultMessage: 'Pandora',
  },
  nowPlayingOnPandora: {
    id: 't.pandora',
    defaultMessage: 'Now Playing on Pandora',
  },
  nowPlayingThumbedUp: {
    id: 't.nowPlayingThumbedUp',
    defaultMessage: 'Thumbed Up Songs',
  },
});

// String constants for use in utils
export const metaTagsDefaultTitle = 'Music and Podcasts, Free and On-Demand | Pandora';
export const metaTagsDefaultDescription =
  'Play the songs, albums, playlists and podcasts you love on the all-new Pandora. Sign up for a subscription plan to stream ad-free and on-demand. Listen on your mobile phone, desktop, TV, smart speakers or in the car.';

export const metaTagsTitle = defineMessages({
  default: {
    id: 't.default',
    defaultMessage: 'Music and Podcasts, Free and On-Demand | Pandora',
  },
  oldBrowse: {
    id: 't.oldBrowse',
    defaultMessage: 'Browse Genre Stations - Pandora',
  },
  browse: {
    id: 't.browse',
    defaultMessage: 'Browse - Home | Pandora',
  },
  backstagePageEnding: {
    id: 't.backstagePageEnding',
    defaultMessage: 'on Pandora | Radio, Songs & Lyrics',
  },
});

export const metaTagsMyCollection = defineMessages({
  myCollection: {
    id: 't.myCollection',
    defaultMessage: 'My Collection',
  },
  all: {
    id: 't.all',
    defaultMessage: 'All',
  },
  artists: {
    id: 't.artists',
    defaultMessage: 'Artists',
  },
  albums: {
    id: 't.albums',
    defaultMessage: 'Albums',
  },
  songs: {
    id: 't.songs',
    defaultMessage: 'Songs',
  },
  stations: {
    id: 't.stations',
    defaultMessage: 'Stations',
  },
  playlists: {
    id: 't.playlist',
    defaultMessage: 'Playlists',
  },
});

export const metaTagsSearch = defineMessages({
  search: {
    id: 't.search',
    defaultMessage: 'Search',
  },
});

export const metaTagsProfile = defineMessages({
  profile: {
    id: 't.profile',
    defaultMessage: 'Profile',
  },
  thumbs: {
    id: 't.thumbs',
    defaultMessage: 'Thumbs',
  },
});

export const metaTagsSettings = defineMessages({
  settings: {
    id: 't.settings',
    defaultMessage: 'Settings',
  },
  account: {
    id: 't.account',
    defaultMessage: 'Account',
  },
  notifications: {
    id: 't.notifications',
    defaultMessage: 'Notifications',
  },
  content: {
    id: 't.content',
    defaultMessage: 'Content',
  },
  subscription: {
    id: 't.subscription',
    defaultMessage: 'Subscription',
  },
  redeem: {
    id: 't.redeem',
    defaultMessage: 'Redeem',
  },
});

export const metaTagDescriptions = defineMessages({
  default: {
    id: 't.default',
    defaultMessage:
      'Play the songs, albums, playlists and podcasts you love on the all-new Pandora. Sign up for a subscription plan to stream ad-free and on-demand. Listen on your mobile phone, desktop, TV, smart speakers or in the car.',
  },
  browse: {
    id: 't.browse',
    defaultMessage:
      "Not sure what you want to hear? Start browsing Pandora for stations you'll love.",
  },
  upgradePremium: {
    id: 't.upgradePremium',
    defaultMessage:
      'Search and play, create playlists, skip, replay, download music and listen ad-free with Pandora Premium.',
  },
  upgradePlus: {
    id: 't.upgradePlus',
    defaultMessage:
      'Create personalized ad-free stations, skip, replay and listen offline with Pandora Plus.',
  },
  plus: {
    id: 't.plus',
    defaultMessage:
      'Listen without ads, create personalized stations, get unlimited skips and replays, listen offline, and enjoy higher quality audio with Pandora Plus',
  },
  premium: {
    id: 't.premium',
    defaultMessage:
      'Search and play any song, create playlists, download your music and listen offline. Unlimited skips and replays, higher quality audio and no ads',
  },
  backstagePage: {
    id: 't.backstagePage',
    defaultMessage:
      "Discover {artist}'s top songs & albums, curated artist radio stations & more. Listen to {artist} on Pandora today!",
  },
});

export const metaTagsUpgrade = defineMessages({
  upgrade: {
    id: 't.upgrade',
    defaultMessage: 'Upgrade to Pandora Plus or Pandora Premium',
  },
  upgradePlus: {
    id: 't.upgrade',
    defaultMessage: 'Upgrade to Pandora Plus',
  },
  upgradePremium: {
    id: 't.upgradePremium',
    defaultMessage: 'Upgrade to Pandora Premium',
  },
  premium: {
    id: 't.premium',
    defaultMessage: 'Pandora Premium - Personalized Radio Meets On-Demand Listening',
  },
});
